"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsersList = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal");
const filter_header_1 = require("client/components/filter-header");
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const button_1 = require("client/components/material/button");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const floating_page_1 = require("client/components/page/floating-page");
const router_1 = require("client/components/router");
const upload_modal_1 = require("client/components/upload-modal");
const store_1 = require("client/modules/app-settings/store");
const store_2 = require("client/modules/providers/store");
const store_3 = require("client/modules/sites/modules/sites-list/store");
const edit_user_1 = require("client/modules/users/modules/users-list/components/edit-user");
const store_4 = require("client/modules/users/store");
const Add_1 = require("material-ui-icons/Add");
const Notifications_1 = require("material-ui-icons/Notifications");
const Warning_1 = require("material-ui-icons/Warning");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const ramda_1 = require("ramda");
const React = require("react");
const react_1 = require("react");
const ReactTooltip = require("react-tooltip");
const app_settings_1 = require("shared/app-settings");
const capitalize_string_1 = require("shared/util/capitalize-string");
const throttle_debounce_1 = require("throttle-debounce");
const store_5 = require("./store");
require("./users-list.less");
const text_field_small_1 = require("client/components/material/text-field/text-field-small");
const columns = [
    {
        label: "Name",
        id: "user.lastName"
    },
    {
        label: "Email",
        id: "user.email"
    },
    {
        label: "Pharmacy Name",
        id: "site.displayName"
    },
    {
        label: "Role",
        id: "group.name"
    },
    {
        label: "",
        id: "user.id"
    },
    {
        label: "",
        id: "user.id"
    }
];
const dummyUser = {
    email: "",
    firstName: "",
    groupId: 0,
    id: 0,
    lastName: "",
    phone: "",
    password: "",
    siteId: 0,
    verification: "",
    verified: false
};
let UsersList = class UsersList extends react_1.Component {
    constructor() {
        super(...arguments);
        this.confirmDeleteUser = null;
        this.sortedBy = {
            label: "",
            value: ""
        };
        this.editId = -1;
        this.routeId = -1;
        this.currentRowIndex = -1;
        this.sortMenu = false;
        this.order = "ASC";
        this.orderBy = "user.lastName";
        this.filterText = "";
        this.isCollapse = true;
        this.autoFocusForm = true;
        this.user = ramda_1.merge(dummyUser, {});
        this.confirmUploadUser = null;
        this.uploadModal = false;
        this.daysPrior = 0;
        this.showDisabled = false;
        //C-097 users pagination
        this.page = 1;
        this.limit = 25;
        this.totalPages = 1;
        this.loadUsers = throttle_debounce_1.debounce(200, () => {
            const options = {
                count: 1000,
                order: this.order,
                search: this.filterText,
                start: 0,
                where: "",
                sort: this.orderBy,
                showDisabled: this.showDisabled,
                page: this.page,
                limit: this.limit //C-097 users pagination
            };
            store_5.usersListStore.loadUsers(options);
        });
        //C-097 users pagination
        this.startsLoadUsers = throttle_debounce_1.debounce(200, () => {
            const options = {
                count: 1000,
                order: this.order,
                search: this.filterText,
                start: 0,
                where: "",
                sort: this.orderBy,
                showDisabled: this.showDisabled,
                page: this.page,
                limit: this.limit //For pagination //C-097
            };
            store_5.usersListStore.loadUsers(options);
        });
        // endregion
        // region Event handlers
        this.onHandleClickRow = (row, index) => {
            if (this.editId === row.id) {
                this.isCollapse = !this.isCollapse;
                this.autoFocusForm = true;
            }
            else {
                this.isCollapse = false;
            }
            this.editId = row.id;
            this.currentRowIndex = index;
            router_1.RouteManager.transitionTo(`/users/${row.id}`);
        };
        this.onHandleClickAddUser = () => {
            this.user = ramda_1.merge(dummyUser, {});
            router_1.RouteManager.transitionTo(`/users/0`);
        };
        this.onHandleClickDeleteUser = (user) => {
            this.confirmDeleteUser = user;
        };
        this.onHandleCredentialUpload = (user) => {
            this.confirmUploadUser = user;
            this.uploadType = "credential";
            this.uploadModal = true;
        };
        this.onHandleImageUpload = (user) => {
            this.confirmUploadUser = user;
            this.uploadType = "image";
            this.uploadModal = true;
        };
        this.onHandleClickCancelUpload = () => {
            this.uploadModal = false;
        };
        this.onHandleClickDeleteUpload = async (upload) => {
            await store_4.usersStore.deleteUpload(upload);
            await store_5.usersListStore.loadUsers();
        };
        this.onHandleClickConfirmDeleteUser = () => {
            if (this.confirmDeleteUser) {
                store_5.usersListStore.deleteUser(this.confirmDeleteUser);
                this.confirmDeleteUser = null;
            }
        };
        this.onHandleClickCancelDeleteUser = () => {
            this.confirmDeleteUser = null;
        };
        this.onHandleSaveUser = async (user) => {
            this.user = user;
            let newUser;
            if (user.id) {
                newUser = await store_5.usersListStore.saveUser(user);
            }
            else {
                newUser = await store_5.usersListStore.createUser(user);
                const { success, code, errProp } = newUser;
            }
            // WIll reload the current user so that if the current user's information has changed
            // it will update in the titlebar component.
            store_4.usersStore.loadUser();
            // Transitions to Edit-User UI Form after new user is created
            if (newUser) {
                router_1.RouteManager.transitionTo(`/users/${newUser.id}`);
                this.loadUsers();
            }
        };
        this.onCallback = (value) => {
            this.autoFocusForm = false;
            this.filterText = value;
            this.loadUsers();
        };
        this.handleAssetsUpload = async (accepted) => {
            await store_4.usersStore.upload(accepted, String(this.editId), this.uploadType);
            await store_5.usersListStore.loadUsers();
            router_1.RouteManager.transitionTo(`/users/${this.editId}`);
        };
        this.handleDisabledToggle = () => {
            this.showDisabled = !this.showDisabled;
            this.loadUsers();
        };
        // C-097 handle pagination input
        this.handleKeyDown = () => {
            if (this.page === Number(""))
                return;
            (this.page !== store_5.usersListStore.currentPage) && this.loadUsers();
        };
        this.renderListRowEditMode = (row, index) => (React.createElement("div", { key: -1 }, !this.isCollapse && (this.editId === row.id || this.routeId === row.id) && (React.createElement(edit_user_1.EditUser, { autoFocusForm: this.autoFocusForm, error: store_5.usersListStore.editUser.error, key: index, loading: store_5.usersListStore.editUser.loading, onCancel: () => {
                this.editId = -1;
                router_1.RouteManager.transitionTo("/users");
                store_5.usersListStore.editUser.error = undefined;
            }, onDelete: this.onHandleClickDeleteUser, onSave: this.onHandleSaveUser, onDeleteUpload: this.onHandleClickDeleteUpload, onCredentialUpload: this.onHandleCredentialUpload, onImageUpload: this.onHandleImageUpload, user: row, status: store_5.usersListStore.editUser.status, userId: row.id }))));
        this.renderEditNewUser = () => (React.createElement("div", { className: "users__new-user" },
            React.createElement(edit_user_1.EditUser, { autoFocusForm: this.autoFocusForm, error: store_5.usersListStore.editUser.error, loading: store_5.usersListStore.editUser.loading, onCancel: () => {
                    router_1.RouteManager.transitionTo("/users");
                    store_5.usersListStore.editUser.error = undefined;
                }, onSave: this.onHandleSaveUser, user: this.user, status: store_5.usersListStore.editUser.status })));
        this.renderListRow = (row, index) => {
            const siteName = (row.site && (row.site.displayName || row.site.name)) || "";
            const displayName = row.lastName && row.firstName
                ? `${row.lastName}, ${row.firstName}`
                : `${row.firstName} ${row.lastName}`;
            const today = moment().startOf("day");
            const uploadswithExpdate = row.uploads.filter(upload => upload.expDate !== null);
            let assetExpired = false;
            for (const item of uploadswithExpdate) {
                const expDate = moment(item.expDate);
                assetExpired = today.isSameOrAfter(expDate);
                if (assetExpired) {
                    break;
                }
            }
            let assetExpiring = false;
            for (const item of uploadswithExpdate) {
                const expDate = moment(item.expDate);
                const alertDateAsset = moment(item.expDate)
                    .subtract(this.daysPrior, "days")
                    .startOf("day")
                    .toString();
                assetExpiring = today.isBetween(alertDateAsset, expDate);
                if (assetExpiring) {
                    break;
                }
            }
            const missingRequiredAssetsforProvArray = this.missingRequiredAssets &&
                this.missingRequiredAssets.length &&
                this.missingRequiredAssets.filter((asset) => asset.id === row.id);
            const rowUploadsArray = row.uploads.map((upload) => upload.connectAssetId);
            //  if rowUploadsArray contains the ids or the assetsArray then it should not have a warning, and missing will be empty
            const missing = missingRequiredAssetsforProvArray &&
                missingRequiredAssetsforProvArray.length &&
                missingRequiredAssetsforProvArray[0].assetsArray &&
                missingRequiredAssetsforProvArray[0].assetsArray.length &&
                missingRequiredAssetsforProvArray[0].assetsArray.filter((num) => num && !rowUploadsArray.includes(num.id));
            let missingRequired = false;
            if (missingRequiredAssetsforProvArray &&
                missingRequiredAssetsforProvArray.length &&
                missingRequiredAssetsforProvArray[0].assetsArray &&
                missingRequiredAssetsforProvArray[0].assetsArray.length > 0 &&
                missing &&
                missing.length > 0) {
                missingRequired = true;
            }
            const deleted = row.deletedAt;
            return [
                React.createElement(list_item_1.MaterialListItem, { className: deleted
                        ? "disabled-site-accent"
                        : assetExpired
                            ? "expired-license-accent"
                            : "", key: index, onClick: () => {
                        this.onHandleClickRow(row, index);
                    } },
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: capitalize_string_1.capitalizeString(displayName) }),
                    React.createElement(list_item_text_1.MaterialListItemText, { className: "mailto", primary: row.email }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: capitalize_string_1.capitalizeString(siteName) }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: capitalize_string_1.capitalizeString(row.group.name) }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: assetExpiring ? (React.createElement(Warning_1.default, { className: "warning-quantity--icon", "data-place": "right", "data-tip": "One or more assets are expiring soon.", "data-for": "warning-icon", fill: "#eeb20d" })) : assetExpired ? (React.createElement(Warning_1.default, { className: "warning-quantity--icon", "data-place": "right", "data-tip": "One or more assets expired.", "data-for": "warning-icon", fill: "#eeb20d" })) : null }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: missingRequired ? (React.createElement(Notifications_1.default, { className: "warning-quantity--icon", "data-tip": "Missing required certifications.", "data-place": "right", "data-for": "warning-icon", fill: "#eeb20d" })) : null })),
                this.renderListRowEditMode(row, index)
            ];
        };
        this.onRequestSort = (property) => {
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            this.loadUsers();
        };
        // endregion
    }
    // region React methods
    componentWillMount() {
        ReactTooltip.rebuild();
        // sitesListStore.loadSites();
        store_3.sitesListStore.loadSitesNoRelation();
        this.routeId = Number(this.props.params[0]);
        if (this.routeId > 0) {
            this.isCollapse = false;
        }
    }
    async componentDidMount() {
        await store_5.usersListStore.loadUsers();
        const daysSetting = await store_1.appSettingsStore.readSettings(app_settings_1.AppOption.DaysPriorProvExpLicense);
        this.daysPrior = Number(daysSetting.value);
        const users = store_5.usersListStore.users.value;
        //C-097 users pagination
        this.totalPages = store_5.usersListStore.totalProviderPage;
        const missingRequiredAssetsArray = await store_2.providersStore.getMissingRequiredAssets(users, "user");
        this.missingRequiredAssets = missingRequiredAssetsArray
            ? Array.from(missingRequiredAssetsArray)
            : [];
        // console.log("this.missingRequiredAssets", this.missingRequiredAssets);
        ReactTooltip.rebuild();
    }
    componentDidUpdate() {
        ReactTooltip.rebuild();
        this.routeId = Number(this.props.params[0]);
        if (this.routeId > 0 && this.editId !== this.routeId) {
            this.isCollapse = false;
            this.editId = this.routeId;
        }
        if (this.props.params.length === 0) {
            this.isCollapse = true;
            this.editId = -1;
        }
    }
    // endregion
    // region Render methods
    render() {
        ReactTooltip.rebuild();
        return (React.createElement("div", { className: "users" },
            React.createElement(ReactTooltip, { id: "warning-icon", className: "tooltip", effect: "solid", place: "left", "data-type": "warning", multiline: true }),
            store_4.usersStore.permissions.ReadUser ? (React.createElement(React.Fragment, null,
                React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                    React.createElement("div", { className: "users__title-wrapper" },
                        React.createElement(kpi_title_1.KpiTitle, { label: "Users" }),
                        store_4.usersStore.permissions.CreateUser && ( // The array of numbers corresponds to the group id, which regulates priviledges.
                        React.createElement(button_1.MaterialButton, { fab: true, primary: true, className: "add-user-btn", onClick: this.onHandleClickAddUser },
                            React.createElement(Add_1.default, null)))),
                    store_4.usersStore.permissions.UpdatePermissions && (React.createElement("div", { className: "users__manage" },
                        React.createElement(button_1.MaterialButton, { primary: true, className: "users__manage-btn", to: "/users/permissions", disabled: false }, "Manage Permissions")))),
                React.createElement(floating_page_1.FloatingPage, null, this.renderInfo()),
                React.createElement(ReactTooltip, { effect: "solid", place: "left" }),
                this.confirmDeleteUser && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Confirm and continue", cancelText: "Cancel and go back", message: `Are you sure you want to delete ${this.confirmDeleteUser.prefix} ${this.confirmDeleteUser.firstName} ${this.confirmDeleteUser.lastName} ${this.confirmDeleteUser.suffix}?`, onCancel: this.onHandleClickCancelDeleteUser, onConfirm: this.onHandleClickConfirmDeleteUser, title: "Are you sure you want to proceed?" })),
                this.uploadModal && this.confirmUploadUser && (React.createElement(upload_modal_1.UploadModal, { onCancel: this.onHandleClickCancelUpload, message: `Please select files for ${this.confirmUploadUser.firstName} ${this.confirmUploadUser.lastName}.`, title: "Upload Documents", onDrop: this.handleAssetsUpload })))) : (store_4.usersStore.showLock())));
    }
    renderInfo() {
        const newUserMode = this.props.params[0] === "0";
        const permissionToViewDisabled = store_4.usersStore.permissions.ViewDisabledSites;
        return (React.createElement("div", { className: "users__main userMain-wrapper" },
            React.createElement("div", { className: "users__data" },
                React.createElement(filter_header_1.FilterHeader, { label: "Search", title: "Users", callBack: this.onCallback, withSwitch: permissionToViewDisabled, switchChecked: this.showDisabled, switchLabel: "Show Disabled", handleToggle: this.handleDisabledToggle, filterText: this.filterText }),
                newUserMode && this.renderEditNewUser(),
                this.renderList(),
                React.createElement("div", { className: "pagination-container-header" },
                    React.createElement("button", { className: "btn-pagination", onClick: () => {
                            if (this.page === 1)
                                return;
                            this.page--;
                            this.loadUsers();
                        } }, "Previous"),
                    React.createElement("div", { className: "pagination-container" },
                        React.createElement("p", null, "Page"),
                        React.createElement("div", { style: { display: 'contents' } },
                            React.createElement("div", { className: "cstmPaginationInput-Wrapper" },
                                React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "pagination-input", autoFocus: true, type: "text", min: 1, max: store_5.usersListStore.totalProviderPage, onChange: (e) => {
                                        const value = Number(e.target.value);
                                        // this.page = Number(e.target.value);
                                        if (value >= 1 && value <= store_5.usersListStore.totalProviderPage) {
                                            this.page = value;
                                        }
                                        else {
                                            if (e.target.value <= store_5.usersListStore.totalProviderPage) {
                                                this.page = value;
                                            }
                                            else {
                                                e.target.value = this.page;
                                            }
                                        }
                                    }, onKeyDown: () => { }, onKeyDownEnterPress: this.handleKeyDown, value: this.page || "" })),
                            React.createElement("div", null, "of"),
                            React.createElement("div", null, store_5.usersListStore.totalProviderPage)),
                        React.createElement("select", { className: "pagination-input", onChange: (e) => {
                                this.limit = Number(e.target.value);
                                this.loadUsers();
                                this.page = 1;
                                if (store_5.usersListStore.totalProviderPage === store_5.usersListStore.currentPage)
                                    return this.startsLoadUsers();
                            }, defaultValue: this.limit },
                            React.createElement("option", { value: "5" }, "5 rows"),
                            React.createElement("option", { value: "10" }, "10 rows"),
                            React.createElement("option", { value: "25" }, "25 rows"),
                            React.createElement("option", { value: "50" }, "50 rows"),
                            React.createElement("option", { value: "100" }, "100 rows"))),
                    React.createElement("button", { className: "btn-pagination1", onClick: () => {
                            if (store_5.usersListStore.currentPage === store_5.usersListStore.totalProviderPage)
                                return;
                            this.page++;
                            this.loadUsers();
                        } }, "Next")))));
    }
    renderList() {
        const { users: { value: users = [] } } = store_5.usersListStore;
        return (React.createElement("div", { className: "users__data__list__info" },
            React.createElement(list_1.MaterialList, { columns: columns, onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: users, renderRow: this.renderListRow, withMargin: false, wideHeader: true, resizableheader: true })));
    }
};
__decorate([
    mobx_1.observable
], UsersList.prototype, "confirmDeleteUser", void 0);
__decorate([
    mobx_1.observable
], UsersList.prototype, "sortedBy", void 0);
__decorate([
    mobx_1.observable
], UsersList.prototype, "editId", void 0);
__decorate([
    mobx_1.observable
], UsersList.prototype, "routeId", void 0);
__decorate([
    mobx_1.observable
], UsersList.prototype, "currentRowIndex", void 0);
__decorate([
    mobx_1.observable
], UsersList.prototype, "sortMenu", void 0);
__decorate([
    mobx_1.observable
], UsersList.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], UsersList.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], UsersList.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], UsersList.prototype, "isCollapse", void 0);
__decorate([
    mobx_1.observable
], UsersList.prototype, "autoFocusForm", void 0);
__decorate([
    mobx_1.observable
], UsersList.prototype, "user", void 0);
__decorate([
    mobx_1.observable
], UsersList.prototype, "permissions", void 0);
__decorate([
    mobx_1.observable
], UsersList.prototype, "confirmUploadUser", void 0);
__decorate([
    mobx_1.observable
], UsersList.prototype, "uploadType", void 0);
__decorate([
    mobx_1.observable
], UsersList.prototype, "uploadModal", void 0);
__decorate([
    mobx_1.observable
], UsersList.prototype, "daysPrior", void 0);
__decorate([
    mobx_1.observable
], UsersList.prototype, "missingRequiredAssets", void 0);
__decorate([
    mobx_1.observable
], UsersList.prototype, "showDisabled", void 0);
__decorate([
    mobx_1.observable
], UsersList.prototype, "page", void 0);
__decorate([
    mobx_1.observable
], UsersList.prototype, "limit", void 0);
__decorate([
    mobx_1.observable
], UsersList.prototype, "totalPages", void 0);
UsersList = __decorate([
    mobx_react_1.observer
], UsersList);
exports.UsersList = UsersList;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/users/modules/users-list/users-list.tsx
// module id = 4152
// module chunks = 0